<div class="signature-container">

  <!-- Signature Type -->
  <div class="signature-options">

    <label class="signature-option">

      <input
        type="radio"
        name="signatureOption"
        value="typed"
        [(ngModel)]="selectedOption"
        (ngModelChange)="onOptionChange()">

      <span>
        Type Full Name
      </span>

    </label>


    <label class="signature-option">

      <input
        type="radio"
        name="signatureOption"
        value="draw"
        [(ngModel)]="selectedOption"
        (ngModelChange)="onOptionChange()">

      <span>
        Draw Signature
      </span>

    </label>


    <label class="signature-option">

      <input
        type="radio"
        name="signatureOption"
        value="upload"
        [(ngModel)]="selectedOption"
        (ngModelChange)="onOptionChange()">

      <span>
        Upload Signature
      </span>

    </label>

  </div>


  <div class="signature-section">

    <!-- ============================================== -->
    <!-- TYPED SIGNATURE -->
    <!-- ============================================== -->

    <div
      *ngIf="selectedOption === 'typed'"
      class="typed-signature">

      <input
        type="text"
        class="form-control"
        placeholder="Enter your full name"
        [(ngModel)]="fullName"
        name="typedSignatureName">


      <div
        *ngIf="fullName"
        class="typed-signature-preview">

        {{ fullName }}

      </div>


      <button
        type="button"
        class="signature-button"
        [disabled]="!fullName.trim()"
        (click)="submitTypedSignature()">

        Use This Signature

      </button>

    </div>


    <!-- ============================================== -->
    <!-- DRAW SIGNATURE -->
    <!-- ============================================== -->

    <div
      *ngIf="selectedOption === 'draw'"
      class="draw-signature">

      <app-signature-pad
        (signatureGenerated)="handleSignaturePad($event)">
      </app-signature-pad>

    </div>


    <!-- ============================================== -->
    <!-- UPLOAD SIGNATURE -->
    <!-- ============================================== -->

    <div
      *ngIf="selectedOption === 'upload'"
      class="upload-signature">

      <input
        type="file"
        class="form-control"
        accept="image/png,image/jpeg,image/jpg,image/webp"
        [disabled]="isUploading"
        (change)="onFileUpload($event)">


      <small class="signature-help">

        Upload a PNG, JPG, JPEG or WEBP image of your signature.

      </small>


      <div
        *ngIf="isUploading"
        class="uploading-message">

        Uploading signature...

      </div>


      <div
        *ngIf="uploadError"
        class="signature-error">

        {{ uploadError }}

      </div>


      <div
        *ngIf="uploadedSignatureUrl"
        class="uploaded-signature-preview">

        <img
          [src]="uploadedSignatureUrl"
          alt="Uploaded signature">

      </div>

    </div>

  </div>


  <!-- ============================================== -->
  <!-- SELECTED SIGNATURE -->
  <!-- ============================================== -->

  <div
    *ngIf="signature"
    class="selected-signature">

    <div class="selected-signature-header">

      <span>
        Selected Signature
      </span>


      <button
        type="button"
        class="remove-signature"
        (click)="removeSignature()">

        Remove

      </button>

    </div>


    <!-- Image / Drawn signature -->
    <div
      *ngIf="isImageSignature(signature)"
      class="final-signature-preview">

      <img
        [src]="signature"
        alt="Selected signature">

    </div>


    <!-- Typed signature -->
    <div
      *ngIf="!isImageSignature(signature)"
      class="final-typed-signature">

      {{ signature }}

    </div>

  </div>


  <small class="signature-disclaimer">

    By providing your signature, you confirm that this
    electronic signature represents your approval of this declaration.

  </small>

</div>